import {
  Flex,
  Icon,
  Input,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Stack,
  Button,
  Text,
  Avatar,
  Box,
  Badge,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { FaEdit, FaArchive } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

function SearchTable3({ tableData, onEdit, onDelete }) {
  // Transform incoming data to match required fields
  const transformedUserData = useMemo(() => {
    if (!Array.isArray(tableData)) return [];

    return tableData.map((user) => ({
      id: user?.id ?? "",
      fullname: user?.name ?? "",
      email: user?.email ?? "",
      status: user?.status ?? "",
      company: user?.companyName ?? "",
      customerCategory: user?.category?.type ?? "",
      driver: user?.driver?.name ?? "",
      driverId: user?.driver?.id ?? "",
      phone: user?.mobile ?? "",
      address: user?.address ?? "",
      second_phone: user?.secondaryMobile ?? "",
      registration: user?.regNo || "",
      pylonCode: user?.paylonCode || "",
      customerCategory: user?.category?.type || "",
      startTime: user?.orderStartTime || "",
      endTime: user?.orderEndTime || "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      extraInfo:user?.extraInfo || "",
      favouriteProducts: Array.isArray(user?.favouriteProducts)
        ? user.favouriteProducts.map((prod) => prod.product.productId)
        : [], 
    }));
  }, [tableData]);
  console.log(transformedUserData, "transformedUserData")
   
  // Columns defined inside the component
  const columns = useMemo(
    () => [
      {
        Header: "ΟΝΟΜΑΣΙΑ ΠΕΛΑΤΗ",
        accessor: "fullname",
        Cell: ({ value }) => {
          const fullName = value?.trim() || "";
          const nameParts = fullName.split(" ").filter(Boolean);

          let initials = "";
          if (nameParts.length === 1) {
            initials = nameParts[0][0]?.toUpperCase() || "";
          } else if (nameParts.length >= 2) {
            initials =
              (nameParts[0][0] || "").toUpperCase() +
              (nameParts[nameParts.length - 1][0] || "").toUpperCase();
          }

          return (
            <Flex align="center" maxW="200px">
              {initials && (
                <Box
                  w="30px"
                  h="30px"
                  me="3"
                  borderRadius="full"
                  bg="teal.300"
                  color="white"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize="sm"
                  fontWeight="bold"
                >
                  {initials}
                </Box>
              )}
              <Text
                isTruncated
                maxW="100px"
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
              >
                {fullName}
              </Text>
            </Flex>
          );
        },
      },
      // {
      //   Header: "Client Name",
      //   accessor: "fullname",
      //   Cell: ({ value }) => (
      //     <Flex align="center" maxW="200px">
      //       <Avatar name={value} w="30px" h="30px" me="3" />
      //       <Text
      //         isTruncated
      //         maxW="120px"
      //         whiteSpace="nowrap"
      //         overflow="hidden"
      //         textOverflow="ellipsis"
      //       >
      //         {value}
      //       </Text>
      //     </Flex>
      //   ),
      // },
      {
  Header: "ΚΑΤΗΓΟΡΙΑ",
  accessor: "customerCategory",
  Cell: ({ value }) => {
    const categoryToGreek = {
      DAILY: "Ημερήσιος",
      WEEKLY: "Εβδομαδιαίος",
    };
    return categoryToGreek[value] || value;
  },
},

      {
        Header: "ΟΔΗΓΟΣ",
        accessor: "driver",
      },
      {
        Header: "ΤΗΛΕΦΩΝΟ",
        accessor: "phone",
      },
          {
                  Header: "ΚΑΤΑΣΤΑΣΗ",
                  accessor: "status",
                  Cell: ({ value }) => {
                    const isActive = value === true || value === "true" || value === 1;
                    return (
                      <Badge
                        colorScheme={isActive ? "teal" : "red"}
                        variant="subtle"
                        borderRadius="full"
                        px={3}
                        py={1}
                      >
                        {isActive ? "Ενεργό" : "Ανενεργό"}
                      </Badge>
                    );
                  },
                },
      // {
      //   Header: "Action",
      //   accessor: "action",
      //   Cell: ({ row }) => (
      //     <Flex gap={3}>
      //       <Icon
      //         as={FaEdit}
      //         color="blue.500"
      //         cursor="pointer"
      //         w="20px"
      //         h="20px"
      //         onClick={(e) => {
      //           e.stopPropagation(); // ⛔️ Prevent row click
      //           onEdit(row.original);
      //         }}
      //       />

      //       {/* <Icon
      //         as={FaArchive}
      //         color="orange.500"
      //         cursor="pointer"
      //         w="20px"
      //         h="20px"
      //         onClick={() => onDelete(row.original)}
      //       /> */}
      //     </Flex>
      //   ),
      // },
    ],
    [onEdit, onDelete]
  );

  const tableInstance = useTable(
    {
      columns,
      data: transformedUserData,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const createPages = (count) => {
    let arrPageCount = [];

    for (let i = 1; i <= count; i++) {
      arrPageCount.push(i);
    }

    return arrPageCount;
  };

  const { getTableBodyProps, headerGroups, page, prepareRow, setGlobalFilter, state, getTableProps,

    gotoPage,
    pageCount,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize } = tableInstance;
  const { pageIndex, pageSize, globalFilter } = state;
  let dotsBeforeShown = false;
  let dotsAfterShown = false;

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex
        align={{ sm: "flex-start", lg: "flex-end" }}
        justify={{ sm: "flex-start", lg: "flex-end" }}
        w="100%"
        px="22px"
        mb="36px"
      >
        <Input
          type="text"
          placeholder="Αναζήτηση…"
          minW="75px"
          maxW="175px"
          fontSize="sm"
          _focus={{ borderColor: "teal.300" }}
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
        />
      </Flex>

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, groupIdx) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={groupIdx}>
              {headerGroup.headers.map((column, colIdx) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={colIdx}>
                  <Flex justify="space-between" align="center" fontSize="12px" color="gray.400">
                    {column.render("Header")}
                    <Icon
                      w="14px"
                      h="14px"
                      color={column.isSorted ? "gray.500" : "gray.400"}
                      as={
                        column.isSorted
                          ? column.isSortedDesc
                            ? TiArrowSortedDown
                            : TiArrowSortedUp
                          : TiArrowUnsorted
                      }
                    />
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>

        <Tbody {...getTableBodyProps()}>
          {page.map((row, rowIdx) => {
            prepareRow(row);
            return (
              <Tr
                {...row.getRowProps()}
                key={rowIdx}
                cursor="pointer"
                _hover={{ bg: "gray.100" }}
                onClick={() => onEdit(row.original)} // 👈 Add click handler here
              >
                {row.cells.map((cell, cellIdx) => (
                  <Td {...cell.getCellProps()} key={cellIdx} fontSize="14px" minW="150px">
                    {cell.render("Cell")}
                  </Td>
                ))}
              </Tr>
            );
          })}
        </Tbody>

      </Table>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        px="22px"
        w="100%"
        px={{ md: "22px" }}
      >
        <Text
          fontSize="sm"
          color="gray.500"
          fontWeight="normal"
          mb={{ sm: "24px", md: "0px" }}
        >
          Showing {pageSize * pageIndex + 1} to{" "}
          {pageSize * (pageIndex + 1) <= tableData.length
            ? pageSize * (pageIndex + 1)
            : tableData.length}{" "}
          of {tableData.length} entries
        </Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button
            variant="no-hover"
            onClick={() => previousPage()}
            transition="all .5s ease"  
            w="40px"
            h="40px"
            borderRadius="50%"
            bg="#fff" 
            border="1px solid lightgray"
            display={
              pageSize === 5 ? "none" : canPreviousPage ? "flex" : "none"
            }
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormPrevious} w="16px" h="16px" color="gray.400" />
          </Button>

          {pageSize === 5 ? (
            <NumberInput
              max={pageCount - 1}
              min={1}
              w="75px"
              mx="6px"
              defaultValue="1"
              onChange={(e) => gotoPage(e)}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper onClick={() => nextPage()} />
                <NumberDecrementStepper onClick={() => previousPage()} />
              </NumberInputStepper>
            </NumberInput>
          ) : (
            Array.from({ length: pageCount }).map((_, index) => {
              const isStart = index < 3;
              const isEnd = index >= pageCount - 2;
              const isNearCurrent =
                index === pageIndex ||
                index === pageIndex - 1 ||
                index === pageIndex + 1;

              if (isStart || isEnd || isNearCurrent) {
                return (
                  <Button
                    key={index}
                    variant="no-hover"
                    transition="all .5s ease"
                    onClick={() => gotoPage(index)}
                    w="40px"
                    h="40px"
                    borderRadius="160px"
                    bg={index === pageIndex ? "teal.300" : "#fff"}
                    border="1px solid lightgray"
                    _hover={{
                      bg: "gray.200",
                      opacity: "0.7",
                      borderColor: "gray.500",
                    }}
                  >
                    <Text
                      fontSize="xs"
                      color={index === pageIndex ? "#fff" : "gray.600"}
                    >
                      {index + 1}
                    </Text>
                  </Button>
                );
              }

              if (index === 3 && !dotsBeforeShown) {
                dotsBeforeShown = true;
                return <Text key={`dots-before-${index}`}>...</Text>;
              }

              if (index === pageCount - 3 && !dotsAfterShown) {
                dotsAfterShown = true;
                return <Text key={`dots-after-${index}`}>...</Text>;
              }

              return null;
            })
          )}

          <Button
            variant="no-hover"
            onClick={() => nextPage()}
            transition="all .5s ease"
            w="40px"
            h="40px"
            borderRadius="160px"
            bg="#fff"
            border="1px solid lightgray"
            display={pageSize === 5 ? "none" : canNextPage ? "flex" : "none"}
            _hover={{
              bg: "gray.200",
              opacity: "0.7",
              borderColor: "gray.500",
            }}
          >
            <Icon as={GrFormNext} w="16px" h="16px" color="gray.400" />
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

export default SearchTable3;
